import { useEffect } from 'react';
import { faBullseyeArrow, faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { StyledContentWrapper } from '../../congratulations-full-screen.styles';
import { FeedbackFooter, FeedbackHeader, FeedbackSection, SharedAccordion } from './components';
import { StyledLoadingContainer, StyledLoadingSpinner, StyledLoadingText, StyledPostRoomCompletionFeedbackWrapper, StyledSectionsContainer } from './post-room-completion-feedback-step.styles';
import type { PostRoomCompletionFeedbackByEchoGoodCommand, PostRoomCompletionFeedbackByEchoImprovement, PostRoomCompletionFeedbackStepProps } from './post-room-completion-feedback-step.types';
const renderGoodCommand = (goodCommand: PostRoomCompletionFeedbackByEchoGoodCommand, index: number, isOpen: boolean, onToggle: () => void) => {
  return <SharedAccordion key={`good-command-${index}`} title={goodCommand.title} isOpen={isOpen} onToggle={onToggle} variant="good" icon={faBullseyeArrow} content={{
    command: goodCommand.command,
    reason: goodCommand.reason
  }} data-sentry-element="SharedAccordion" data-sentry-component="renderGoodCommand" data-sentry-source-file="post-room-completion-feedback-step.tsx" />;
};
const renderImprovement = (improvement: PostRoomCompletionFeedbackByEchoImprovement, index: number, isOpen: boolean, onToggle: () => void) => {
  return <SharedAccordion key={`improvement-${index}`} title={improvement.title} isOpen={isOpen} onToggle={onToggle} variant="improvement" icon={faExclamationTriangle} content={{
    commands: improvement.problemCommands,
    recommendation: improvement.recommendation,
    commandLabel: improvement.problemCommands.length === 1 ? 'Missing Command' : 'Missing Commands'
  }} data-sentry-element="SharedAccordion" data-sentry-component="renderImprovement" data-sentry-source-file="post-room-completion-feedback-step.tsx" />;
};
export const PostRoomCompletionFeedbackStep = ({
  isLoading,
  postRoomCompletionFeedback,
  hasError,
  onAutoAdvance,
  roomCode
}: PostRoomCompletionFeedbackStepProps) => {
  useEffect(() => {
    if (hasError && !isLoading && onAutoAdvance) {
      onAutoAdvance();
    }
  }, [hasError, isLoading, onAutoAdvance]);
  if (isLoading) {
    return <StyledContentWrapper data-content="post-room-completion-feedback-by-echo">
        <StyledPostRoomCompletionFeedbackWrapper>
          <StyledLoadingContainer>
            <StyledLoadingSpinner color="info" />
            <StyledLoadingText>Loading...</StyledLoadingText>
          </StyledLoadingContainer>
        </StyledPostRoomCompletionFeedbackWrapper>
      </StyledContentWrapper>;
  }
  const hasGoodCommands = (postRoomCompletionFeedback?.analysis?.goodCommands?.length ?? 0) > 0;
  const hasImprovements = (postRoomCompletionFeedback?.analysis?.improvements?.length ?? 0) > 0;
  return <StyledContentWrapper data-content="post-room-completion-feedback-by-echo" data-sentry-element="StyledContentWrapper" data-sentry-component="PostRoomCompletionFeedbackStep" data-sentry-source-file="post-room-completion-feedback-step.tsx">
      <StyledPostRoomCompletionFeedbackWrapper data-sentry-element="StyledPostRoomCompletionFeedbackWrapper" data-sentry-source-file="post-room-completion-feedback-step.tsx">
        <FeedbackHeader showNightOwlPill={true} data-sentry-element="FeedbackHeader" data-sentry-source-file="post-room-completion-feedback-step.tsx" />

        {postRoomCompletionFeedback?.analysis && <StyledSectionsContainer>
            {hasGoodCommands && <FeedbackSection title="Your winning formula" items={postRoomCompletionFeedback.analysis.goodCommands} isLoading={false} skeletonCount={3} renderItem={renderGoodCommand} type="good-commands" roomCode={roomCode} />}

            {hasImprovements && <FeedbackSection title="Level up zone" items={postRoomCompletionFeedback.analysis.improvements} isLoading={false} skeletonCount={3} renderItem={renderImprovement} type="to-improve" roomCode={roomCode} />}
          </StyledSectionsContainer>}

        <FeedbackFooter data-sentry-element="FeedbackFooter" data-sentry-source-file="post-room-completion-feedback-step.tsx" />
      </StyledPostRoomCompletionFeedbackWrapper>
    </StyledContentWrapper>;
};